import React from 'react';
import { RetryIcon } from '@fluentui/react-northstar';

/**
 * Every Refresh button's icon. An SVG, as the toolbar icons beside it are: the Fabric font glyph it replaced sat about
 * a pixel high on iPhone Safari, which places font glyphs differently (Shaun, 2026-10-20). Drawn at 14px, the old
 * glyph's size - the circle fills its whole box, so at Northstar's 16px it looked heavier than the narrower icons
 * around it. `outline` for a plain button: outside a Northstar Button the icon defaults to its filled version.
 */
export const RefreshIcon = ({ outline }: { outline?: boolean }) => (
  <RetryIcon
    outline={outline}
    styles={{ width: '14px', height: '14px', '& svg': { width: '14px', height: '14px' } }}
  />
);
